export default __webpack_public_path__ + "static/media/Tanzraum.ab73083a.webp";